import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ReferralHash from "../../../../common/referral-hash";

import "features/new/collective/component/view.scss";

const CollectiveView = () => (
  // { plans, activePlan, changePlan }) =>
  <section className="main__collective" id="collective">
    <div className="collective__container">
      <h2 className="collective__headline">
        Join Parlor
        {/*Join The Collective*/}
      </h2>
      <p className="collective__description">
        From cultural gatherings and dating to thought-leadership panels and
        business networking events we provide a full social calendar for our
        members, allowing them to make the most out of their time.
      </p>
    </div>
    <Link
      className="collective__button_2020"
      to={
        "/application/sign-up" +
        (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
      }
      onClick={() => {
        window.dataLayer.push({ event: "applicationVisitedfromCollective" });
      }}
    >
      Request Invite
    </Link>
  </section>
);

CollectiveView.propTypes = {
  plans: PropTypes.array,
  activePlan: PropTypes.number,
  changePlan: PropTypes.func,
};

export default CollectiveView;
